import React from 'react'

import { FEEDBACK } from '../../constants'
import blueThumbsDown from '../../images/blue-thumb-down.svg'
import blueThumbsUp from '../../images/blue-thumb-up.svg'
import whiteThumbsDown from '../../images/white-thumb-down.svg'
import whiteThumbsUp from '../../images/white-thumb-up.svg'

/**
 * Feedback component for providing relevance feedback on query results.
 *
 * @see https://github.com/aws-samples/aws-kendra-transcribe-media-search/blob/main/finderapp/src/search/resultsPanel/components/Feedback.tsx
 * @example
 * const submitFeedback = (relevance, queryResultItem) => { ... }
 * const queryResultItem = { ... }
 * return <Feedback submitFeedback={submitFeedback} queryResultItem={queryResultItem} />
 */
export default class Feedback extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      relevance: undefined
    }
  }

  setRelevance(relevance) {
    this.setState({ ...this.state, relevance })
  }

  submitFeedback = relevance => () => {
    this.setRelevance(relevance)
    this.props.submitFeedback(relevance, this.props.queryResultItem)
  }

  render() {
    const { relevance } = this.state

    return (
      <span className="feedback-buttons">
        <img
          alt="relevant"
          src={relevance === FEEDBACK.RELEVANT ? blueThumbsUp : whiteThumbsUp}
          onMouseOver={event => {
            event.currentTarget.src = blueThumbsUp
          }}
          onFocus={event => {
            event.currentTarget.src = blueThumbsUp
          }}
          onMouseOut={event => {
            if (relevance !== FEEDBACK.RELEVANT) {
              event.currentTarget.src = whiteThumbsUp
            }
          }}
          onBlur={event => {
            if (relevance !== FEEDBACK.RELEVANT) {
              event.currentTarget.src = whiteThumbsUp
            }
          }}
          onClick={this.submitFeedback(FEEDBACK.RELEVANT)}
        />
        <img
          alt="not relevant"
          src={
            relevance === FEEDBACK.NOT_RELEVANT
              ? blueThumbsDown
              : whiteThumbsDown
          }
          onMouseOver={event => {
            event.currentTarget.src = blueThumbsDown
          }}
          onFocus={event => {
            event.currentTarget.src = blueThumbsDown
          }}
          onMouseOut={event => {
            if (relevance !== FEEDBACK.NOT_RELEVANT) {
              event.currentTarget.src = whiteThumbsDown
            }
          }}
          onBlur={event => {
            if (relevance !== FEEDBACK.NOT_RELEVANT) {
              event.currentTarget.src = whiteThumbsDown
            }
          }}
          onClick={this.submitFeedback(FEEDBACK.NOT_RELEVANT)}
        />
      </span>
    )
  }
}
